"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useCarousel } from "@/components/ui/carousel";
import { cn } from "@/lib/utils";
interface Props {
  images: {
    url: string;
    alt: string;
  }[];
}
export function GalleryThumbnails(t0) {
  const $ = _c(9);
  const {
    images
  } = t0;
  const {
    api,
    selectedIndex
  } = useCarousel();
  if (images.length <= 1) {
    return null;
  }
  let t1;
  if ($[0] !== api || $[1] !== images || $[2] !== selectedIndex) {
    let t2;
    if ($[4] !== api || $[5] !== selectedIndex) {
      t2 = (image, index) => <button key={`thumb-${image.url}-${index}`} type="button" data-testid="gallery-thumbnail" onClick={() => api?.scrollTo(index)} className={cn("relative size-25 shrink-0 rounded-lg overflow-hidden border-2 transition-colors", selectedIndex === index ? "border-primary" : "border-transparent opacity-60 hover:opacity-100")}><Image src={image.url} alt={image.alt} fill={true} sizes="100px" loading={index === 0 ? "eager" : "lazy"} className="object-cover" /></button>;
      $[4] = api;
      $[5] = selectedIndex;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = images.map(t2);
    $[0] = api;
    $[1] = images;
    $[2] = selectedIndex;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <div className="hidden lg:flex flex-wrap gap-2 mt-3 justify-center">{t1}</div>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}